import { withInstall } from '../../utils/install';
import DatePicker from './index.vue';

export const IvueDatePicker = withInstall(DatePicker);
export default IvueDatePicker;

export * from './index.vue';
